import BusinessProfileForm from '../components/BusinessProfileForm';
import {useLocation, useNavigate} from 'react-router-dom';
import {useEffect, useState} from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Stack } from '@mui/material';
import {useCreateBusinessProfileHandler} from "../dataHandlers/createBusinessProfileHandler";
import {usePermissions} from "../../../hooks/usePermissions";
import {useActionDeniedSnackbar} from "../../../hooks/useActionDeniedSnackbar";
import {CREATE_BUSINESS_PROFILE} from "../../../constants/eInvoicePermissions";
import {useSelector} from "react-redux";

export default function CreateBusinessProfilePage() {
  useDocumentTitle('New Business Profile Form');
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isRootUser = useSelector(state => state?.user?.user?.is_root_user)
  console.log("is root user?:",isRootUser)
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();

  const onBusinessProfileCreated = () => {
    navigate('/business-profiles');
  }

  const { onSubmit, error, isPending } = useCreateBusinessProfileHandler({ onSuccess: onBusinessProfileCreated})

  useEffect(() => {
    if (loading) {
      return;
    }
    const createPermission = CREATE_BUSINESS_PROFILE;
    if (!hasEInvoicePermission(createPermission) || !isRootUser) {
      showActionDeniedSnackbar();
      navigate('/business-profiles', {
        replace: true,
      });
    }
  }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);

  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const businessProfile = location.state?.businessProfile;

  const onSaveForm = async (data) => {
    setIsSubmitting(true);
    try {
      await onSubmit(data);
    } finally {
        setIsSubmitting(false);
    }
  };

  const onCancel = async () => {
     navigate(location.state?.from || '/business-profiles');
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <BusinessProfileForm
        onSubmit={onSaveForm}
        onCancel={onCancel}
        initialData={businessProfile || {}}
        apiErrors={error}
        isLoading={isSubmitting || isPending}
      />
    </Stack>
  );
}
